module.exports = __webpack_public_path__ + "img/xmasParty1.d9fe6d10.jpg";